// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Skeleton, Stack, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PanePaper from '../../../Molecules/PanePaper';
import { ResourcePosition } from '../../Settings/Documents/Positions/ResourcePositionAssignment';
import { DocumentS } from '../../../Templates/Documents/DocumentS';
import GrayBox from '../../../Atoms/GrayBox';
import ResourcePositionItem from './ResourcePositionItem';
import AddPositionResourceItem from './AddPositionResourceItem';

const ResourceProductsPane = () => {
  const { id: resourceId } = useParams();
  const [loading, setLoading] = useState(false);
  const [lastModified, setLastModified] = useState(new Date());
  const [resourcePositionFavorites, setResourcePositionFavorites] = useState<ResourcePosition[] | null>();
  const lengthResourcePositionFavorites = resourcePositionFavorites?.length ?? 0;

  useEffect(() => {
    if (resourceId) {
      setLoading(true);
      DocumentS.fetchResourcePositionFavorites(resourceId)
        .then(setResourcePositionFavorites)
        .finally(() => setLoading(false));
    }
  }, [resourceId, lastModified]);

  return (
    <PanePaper
      withShadow
      withoutBorder
      title="Verknüpfte Produkte"
      rightSection={<AddPositionResourceItem onSave={() => setLastModified(new Date())} />}
    >
      {loading ? (
        Array.from(Array(3)).map(() => <Skeleton key={Math.random()} radius="md" height={20} width="100%" mb="xs" />)
      ) : (
        <div>
          {lengthResourcePositionFavorites > 0 ? (
            <GrayBox>
              <Stack spacing="xs">
                {resourcePositionFavorites?.map((resourcePosition) => (
                  <ResourcePositionItem
                    key={resourcePosition.id}
                    resourcePosition={resourcePosition}
                    favoritePosition
                  />
                ))}
              </Stack>
            </GrayBox>
          ) : (
            <Text italic color="dimmed" size="xs" weight="lighter">
              Noch nichts hinzugefügt.
            </Text>
          )}
        </div>
      )}
    </PanePaper>
  );
};

export default ResourceProductsPane;
